/**
 * useTranscriptScroll Hook
 * 
 * Manages automatic scrolling to bottom for new messages and hints.
 */

import { useRef, useEffect } from 'react';

interface UseTranscriptScrollReturn {
  shouldScrollToBottom: React.MutableRefObject<boolean>;
  triggerScroll: () => void;
}

export function useTranscriptScroll(
  messages: any[],
  hints: any[]
): UseTranscriptScrollReturn {
  const shouldScrollToBottom = useRef<boolean>(false);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    shouldScrollToBottom.current = true;
  }, [messages]);

  // Auto-scroll to bottom when new hints are added
  useEffect(() => {
    shouldScrollToBottom.current = true;
  }, [hints]);

  const triggerScroll = () => {
    shouldScrollToBottom.current = true;
  };

  return {
    shouldScrollToBottom,
    triggerScroll
  };
}

